export default {"src":"/_next/static/media/File.8a961953.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};